<script>
export default {
  name: 'PanoramaSpotIcon',
  props: {
    icon: String
  },
  render (createElement) {
    return createElement(this.$panorama.spot.icons[this.icon] || 'span')
  }
}
</script>
